module.exports = "/packs/chevron-right-c5a68d9b74f667a9af28b6ca7d70bcfc.svg";